module.exports = __webpack_public_path__ + "static/img/view.40b7fb79.svg";